import React from "react";
import {
  Outlet,
  useLoaderData,
  useNavigate,
  useParams,
} from "react-router-dom";
import { Form as FinalForm } from "react-final-form";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Auth } from "aws-amplify";
import { FormSelect } from "../../_components/_finalFormSpecific";
import { getVendorsForAuthorizedUser } from "../../_gateway/vendorGateway";
import { Vendors } from "../../_types";

export async function loader() {
  try {
    const currUser = await Auth.currentAuthenticatedUser();
    if (!currUser) return null;
  } catch (e) {
    return null;
  }
  // The user is authenticated, we grab necessary user data based on their email on the server
  const response = await getVendorsForAuthorizedUser();
  // return redirect here if only one vendor
  return response;
}

export function VendorSelectionPage() {
  const data = useLoaderData() as Vendors;
  const { vendorId } = useParams();
  const navigate = useNavigate();

  // This will be used for a dropdown if the contact has multiple vendors
  const onSelectionChange = (e: React.ChangeEvent<HTMLElement>) => {
    if (e.target instanceof HTMLSelectElement) {
      return navigate(`${e.target.value}`);
    }

    return null;
  };

  return (
    <div>
      {data.length > 1 ? (
        <FinalForm
          initialValues={{ vendorId }}
          onSubmit={() => {}}
          render={({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Col xs={3}>
                  <FormSelect
                    name="vendorId"
                    label=""
                    options={data}
                    serverError=""
                    onChange={onSelectionChange}
                  />
                </Col>
              </Row>
            </Form>
          )}
        />
      ) : (
        <h4>{data[0].name}</h4>
      )}
      <Outlet />
    </div>
  );
}
